/**
 * Formats OEM hardware fields for Fleet / device rows.
 * Returns null when neither manufacturer nor model is known.
 */
export function formatDeviceHardware(
  manufacturer: string | null | undefined,
  model: string | null | undefined,
): string | null {
  const make = manufacturer?.trim() || null;
  const deviceModel = model?.trim() || null;
  if (make && deviceModel) {
    if (deviceModel.toLowerCase().startsWith(make.toLowerCase())) {
      return deviceModel;
    }
    return `${make} · ${deviceModel}`;
  }
  return make ?? deviceModel;
}
